export default {
  settings: {
    'endpointsSectionTitle': 'Puntos finales del servicio (URI o URL completa)',
    'language': 'Lengua',
    'appLocale': 'Localización de la aplicación',
    'unit': 'Unidad',
    'areaUnit': 'Unidad de área',
    'saveToLocalStorage': 'Guardar en mi navegador',
    'routeInstructions': 'Instrucciones de la ruta',
    'randomizedIsochroneColors': 'Colores de las isócronas aleatorias',
    'distanceMarkers': 'Marcadores de distância',
    'elevationProfile': 'Perfil de altitud',
    'mapSettings': 'Vista del mapa e información adicional',
    'defaultMapSettingsRestored': 'Se ha restaurado y guardado la configuración por defecto del mapa',
    'endpointsTitle': {
      'directions': 'Direcciones',
      'isochrones': 'Isócronas',
      'geocodeSearch': 'Búsqueda por geocódigo',
      'autocomplete': 'Sugerencias de geocodificación',
      'pois': 'Puntos de interés',
      'reverseGeocode': 'Geocodificación inversa'
    },
    'apiKey': 'clave da API',
    'customApiKey': 'Clave da API personalizada',
    'apiBaseUrl': 'URL base de la API',
    'invalidSettingsValue': 'Valor(es) de configuración no válido(s). Por favor, compruebe los campos o restaure los valores por defecto',
    'restoreDefaults': 'Valores predeterminados',
    'advanced': 'Avanzado',
    'mapSettingsSaved': 'Configuraciones guardadas',
    'alwaysFitBounds': 'Ajuste siempre el encuadre de los elementos en el mapa cuando cambie la ruta',
    'routeExtraInfo': 'Información adicional sobre la ruta',
    'mapViewOptions': 'Opciones de visualización del mapa',
    'advancedSettingsWarning': 'No modifique los ajustes siguientes si no sabe lo que está haciendo.',
    'customOverlayerTileProviderUrl': 'URL del proveedor de capas personalizado',
    'customTileProviderUrl': 'URL del proveedor de imágenes de mapas personalizados (tiles provider)',
    'defaultTilesProvider': 'Proveedor de imágenes de mapas estándar (tiles provider)',
    'customTileProviderUrlHint': 'https://domain.tld/path/{z}/{x}/{y}.ext?claveOpcional=valor',
    'prioritizeSearchingForNearbyPlaces': 'Priorizar la búsqueda de lugares cercanos',
    'defaultProfile': 'Perfil estándar',
    'compressDataUrlSegment': 'Comprimir el segmento de la URL después de /data/',
    'autoFitHighlightedBounds': 'Encuadrar automáticamente los elementos seleccionados',
    'reloadToApplyLanguageChangeTitle': 'Debe recargar la aplicación',
    'reloadToApplyLanguageChangeText': 'Para que el cambio de idioma se aplique por completo es necesario recargar la aplicación. ¿Recargar ahora?',
    'resetShownOnceTooltips': 'Mostrar el tutorial cuando se carga la aplicación',
    'convertStopAfterRouteEndingToDestination': 'La parada añadida tras el final de la ruta se convierte en el destino final',
    'skipAllSegments': 'Ruta recta para todos los segmentos',
    'useStopOptimization': 'Optimizar la ruta cuando se crea una parada mediante la función de arrastrar y soltar'
  }
}
